import {JsonObject, JsonProperty} from 'json2typescript';
import {Season} from '@app/order-assortment/model/season/season';
import {Comparable} from '@app/core/services/comparable';
import {isNil} from 'lodash';

@JsonObject('Season')
export class SeasonImp extends Comparable<SeasonImp> implements Season {

  @JsonProperty('id', String)
  private _id: string = undefined;

  @JsonProperty('name', String)
  private _name: string = undefined;

  constructor(id?: string, name?: string) {
    super();
    this._id = id;
    this._name = name;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  equals(otherSeason: Season) {
    if (isNil(otherSeason)) {
      return false;
    }
    return this.id === otherSeason.id && this.name === otherSeason.name;
  }
}
